import { Loader } from "Components/Loader";
import { PreOrderList } from "Requests/Partners/PreBudgets";
import { OrderListItem } from "./OrderListItem";

interface OrdersListProps {
  orderList?: PreOrderList[];
  loading: boolean;
}

const columns = [
  {
    title: "Nome do paciente",
    key: "patient",
  },
  {
    title: "CPF",
    key: "cpf",
  },
  {
    title: "E-mail",
    key: "email",
  },
  {
    title: "Agendamento/horário",
    key: "schedule",
  },
  {
    title: "Nome do parceiro",
    key: "client",
  },
  {
    title: "Data de recebimento",
    key: "created_at",
  },
  {
    title: "Status",
    key: "status",
  },
  {
    title: "Detalhes",
    key: "details",
  },
];

export const OrderList = ({ orderList, loading }: OrdersListProps) => {
  return (
    <table className="table-content small-separate details">
      <thead>
        <tr>
          {columns.map((columnsItem) => (
            <th key={columnsItem.key}>{columnsItem.title}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {orderList &&
          orderList?.length >= 1 &&
          orderList?.map((orderItem) => (
            <OrderListItem order={orderItem} key={orderItem.id} />
          ))}

        {orderList && orderList.length == 0 && (
          <tr>
            <td colSpan={7} className="text-center text-purple">
              Oops! Parece que nada foi encontrado...
            </td>
          </tr>
        )}

        {loading && (
          <tr>
            <td colSpan={7} className="text-center">
              <Loader />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
